import { FC } from "react";

import { SecondaryOverlay } from "components/constants";
import { t } from "i18n/i18n";
import { Button } from "mds/components/Button";
import { IconText } from "mds/components/IconText";
import { MenuItem } from "mds/components/Menu";
import { InstructorNotesIcon } from "mds/icons";
import { useAppSelector } from "store/index";
import { pageSelectors } from "store/selectors";
import { useParams } from "utils/routing";
import { useOverlayControls } from "utils/routing/hooks/use-overlay-controls";

export const InstructorNotesPanelToggleButton: FC<{
  isMenuItem?: boolean;
}> = ({ isMenuItem = false }) => {
  const pathParams = useParams();
  const selectedPageId = pathParams.pageId;
  const selectedPage = useAppSelector((s) => pageSelectors.selectById(s, selectedPageId));
  const { isSelected, togglePanel } = useOverlayControls(SecondaryOverlay.InstructorNotes);

  if (!selectedPage) {
    return null;
  }

  if (isMenuItem) {
    return (
      <MenuItem
        eventName="Page Notes - Toggle"
        eventProps={{ isOpened: !isSelected }}
        onClick={togglePanel}
      >
        <IconText
          iconStart={<InstructorNotesIcon />}
          text={t("content_sidebar.title.InstructorNotes")}
        />
      </MenuItem>
    );
  }

  return (
    <Button
      eventName="Page Notes - Toggle"
      eventProps={{ isOpened: !isSelected }}
      isSelected={isSelected}
      kind="squareLegacy"
      size="l"
      title={t("content_sidebar.title.InstructorNotes")}
      isSquare
      onClick={togglePanel}
    >
      <InstructorNotesIcon />
    </Button>
  );
};
